"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createErrorInfoKey = void 0;
var createErrorInfoKey = function (_a) {
    var url = _a.url, _b = _a.method, method = _b === void 0 ? '' : _b, _c = _a.requestBody, requestBody = _c === void 0 ? {} : _c;
    return [url.toLowerCase(), method.toLowerCase(), JSON.stringify(requestBody)].join('-');
};
exports.createErrorInfoKey = createErrorInfoKey;
